import { render, staticRenderFns } from "./CoachMetrics.vue?vue&type=template&id=2132b60e&"
import script from "./CoachMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./CoachMetrics.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports